import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Utils } from '../../Utils';
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import Form from '../../components/Forms/Form/Form';

import './ProfileDeliveryAddresses.css'; 

class ProfileDeliveryAddresses extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      hiding: false,
      show: false,
      list_items: [],
      is_form: false,
      item_id: null, // a szerkesztett cím id-ja
    };
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.hide();
    this.load();
  }

  load() {
    Utils.get_server_data(
      '', 
      {ajax_event: 'profile_delivery_list', APICACHE: 'false'}, 
      {ajax_event: 'profile_delivery_list'}
    )
      .then((res) => {
        this.setState({
          list_items: res.items,
          show: true
        })
      });
  }

  show() {
    this.load();
  }

  hide() {
    if (this.state.is_form)
    {
      this.setState({is_form: false, item_id: 0});
    }
    else {
      this.setState({hiding: true}, function() {
        setTimeout(() => {
          this.setState({show: false, hiding: false});
        }, 200);
      });
    }
  }
  
  handle_change_default_addres_click(event, address) {
    Utils.get_server_data(
      '', 
      {ajax_event: 'profile_delivery_change_default_address', APICACHE: 'false'}, 
      {ajax_event: 'profile_delivery_change_default_address', formData: JSON.stringify({id: address.id})}
    )
      .then((res) => {
        if (parseInt(res.success) === 1)
        {
          let list_items = this.state.list_items;

          list_items.forEach(item => item.is_default_int = parseInt(item.id) !== parseInt(address.id) ? 0 : 1);
          
          this.setState({list_items});
        }
      });
  }

  handle_delete_addres_click(e, address) {
    window.AppRef.current.set_dialog_message(i18n.t('profileDeliveryAddressesDeleteConfirm'), {
      cancel: true,
      callback: () => 
      {
        Utils.get_server_data(
          '', 
          {ajax_event: 'profile_delivery_delete', APICACHE: 'false'}, 
          {ajax_event: 'profile_delivery_delete', formData: JSON.stringify({id: address.id})}
        )
          .then((res) => {
            if (parseInt(res.success) === 1)
            {
              this.load();
            }
          });        
      }
    });
  }

  toggle() {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show();
    }
  }

  handle_add_addres_click(e) {
    this.setState({ is_form: true });
  }

  handle_change_addres_click(event, address) {
    this.setState({is_form: true, item_id: address.id});
  }

  render() {
    const { show, hiding, is_form, item_id } = this.state;
    let list_items = this.state.list_items;

    list_items = list_items.filter((item) => {
      return item.postal_name_txt.length
      && item.postal_name_txt.length
      && item.postal_city_txt.length
      && item.postal_street_txt.length
      && item.postal_zip_txt.length;
    });

    if (!show) return '';

    return <div className={`container floating_container page_checkout page_profile_delivery_addresses ${hiding ? 'out' : ''}`}>
          <div key={is_form + item_id} className="content">

          {is_form 
            ? <PageHeader parent_ref={this} no_close title={i18n.t(!!item_id ? 'profileDeliveryAddressesEditTitle' : 'profileDeliveryAddressesAddTitle')} />
            : <PageHeader parent_ref={this} no_close title={i18n.t('profileDeliveryAddressesTitle')} />}
          
          <div className='container_inner'>

          {is_form ? <>
            <Form name="profile_delivery" form_source="server" form_data={{item_id}} submit_text={i18n.t('save')} parent={this} />
          </> : <>
            <form>
              {list_items.map((address) => 
                <div key={address.id} className={`field radio ${parseInt(address.is_default_int) ? 'selected' : ''}`}>
                  <div className="radio">
                    <input id={`address_${address.id}`} checked={parseInt(address.is_default_int)} type="radio" value={parseInt(address.id)} onChange={(e) => this.handle_change_default_addres_click(e, address)} /> 
                    <label htmlFor={`address_${address.id}`}>
                      <p>{address.postal_name_txt}</p>  
                      <p>{address.postal_city_txt}</p>  
                      <p>{address.postal_street_txt}</p>  
                      <p>{address.postal_zip_txt}</p>  
                    </label>
                    <div className="icons">
                      <ReactSVG onClick={(e) => this.handle_change_addres_click(e, address)} src="assets/images/edit_black.svg" />
                      <ReactSVG onClick={(e) => this.handle_delete_addres_click(e, address)} src="assets/images/close.svg" />
                    </div>
                  </div> 
                </div> 
              )}
            </form>

           <button onClick={(e) => this.handle_add_addres_click(e)} type="button" className="button">{i18n.t('profileDeliveryAddressesAddAddress')}</button>
          </>}

          </div> 
          </div>
      </div>;
  }
}

export default ProfileDeliveryAddresses;